import type { ValidationStatus } from '@/types/catalog/common'
import { VpIcon } from '@vtmn-play/react'
import { useTranslation } from 'react-i18next'
import './model-validation-status.scss'

const STATUS_COLOR: Record<ValidationStatus, string> = {
  VALIDATED: 'var(--vp-semantic-color-status-positive)',
  CREATED: 'var(--vp-semantic-color-content-quiet)',
  PROPOSAL_VALIDATED: 'var(--vp-semantic-color-status-warning)',
  CANCELLED: 'var(--vp-semantic-color-status-negative)',
}

function getStatusIcon(status: ValidationStatus) {
  switch (status) {
    case 'VALIDATED':
      return 'check-circle'
    case 'CREATED':
      return 'add-circle'
    case 'PROPOSAL_VALIDATED':
      return 'time'
    case 'CANCELLED':
      return 'close-circle'
    default:
      return 'warning-error'
  }
}

export function ModelValidationStatus({
  validationStatus,
}: Readonly<{
  validationStatus: ValidationStatus
}>) {
  const { t } = useTranslation()

  return (
    <div
      className="validation-status-badge"
      style={{ color: STATUS_COLOR[validationStatus] }}
      data-testid="model-card_validation-status"
    >
      <span className="sr-only">
        {t('products-page.filters.groups.homologation_statuses')}
        :
        {' '}
      </span>
      <VpIcon size={16} name={getStatusIcon(validationStatus)} />
      <span>
        {t(
          `products-page.product-card.validation-status.${validationStatus}`,
        )}
      </span>
    </div>
  )
}
